export default __webpack_public_path__ + "static/media/spotting-ON.ddc5ba7d.png";